import { createFileRoute } from '@tanstack/react-router';
import { PAGE_PATHS, Permission } from '../../../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/platform/asset-aging/{-$mode}/{-$id}/')({
  beforeLoad: ({ context, params, preload }) => {
    const { id: endOfURL, mode: oneBeforeLast } = params;
    const mode = endOfURL === 'create' ? 'create' : oneBeforeLast === 'edit' ? 'edit' : undefined;
    const path = PAGE_PATHS.ASSET_AGING;
    const permissionsByMode =
      mode === 'edit'
        ? context.userPermissions.hasAllowedPermission({ path, permission: Permission.UPDATE })
        : mode === 'create'
          ? context.userPermissions.hasAllowedPermission({ path, permission: Permission.UPDATE })
          : undefined;
    const isAllowed = !!(context.userPermissions.hasAllowedPermission({ path }) || permissionsByMode);
    context.validatePermissions({ isAllowed, preload });
  },
});
